enum OrderClientState {
  ClientReceived = 0,
  Payment = 1,
  SendingToKitchen = 2,
  KitchenSendError = 3,
  KitchenSendSuccess = 4,
  SendingToMaitred = 5,
  MaitredSendError = 6,
  MaitredSendSuccess = 7,
}

export { OrderClientState };
